import { CButton, CCol, CFormCheck, CModal, CModalBody, CModalFooter } from '@coreui/react'
import React, { useState, useEffect, useContext } from 'react'
import { CustomDescriptionBox } from 'src/components'
import CustomMultiSelect from 'src/components/customMultiSelect/customMultiSelect'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import PricedIcon from 'src/assets/Content-Icons/PNGs/priced-icon.png'
import FreeGiftIcon from 'src/assets/Content-Icons/PNGs/free-gift-icon.png'
import { isEmpty } from 'lodash'
import { GlobalContext } from 'src/views/context/GlobalState'
import Select from 'react-select'
import { getThumbnail, masterAndChildIntersection } from '../../utils/helper'
import ImageNotFound from '../../../assets/image-not-found.jpg'
import Loading from 'react-fullscreen-loading'
import TagsInput from 'react-tagsinput'
import '../cms/react-tagsinput.css'
import { AppContext } from 'src/views/context/app'

const CreateChannelModal = ({
  data = {},
  onCancel,
  onCreate,
  onUpdate,
  categoryMaster,
  countriesMaster,
  subscriptionMaster,
  PPVMaster,
  ratingMaster,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, accountObj } = useContext(AppContext)
  let isGeoBlockAllowed = accountObj?.od_resource_allowances?.geo_block
  const [channelName, setChannelName] = useState('')
  const [description, setDescription] = useState('')
  const [category, setCategory] = useState([])

  const [isRestricted, setIsRestricted] = useState(true)
  const [pricingModel, setPricingModel] = useState(['SUBSCRIPTION'])
  const [subscriptions, setSubscriptions] = useState([])
  const [ppv, setPpv] = useState([])

  const [status, setStatus] = useState(true)

  const [rating, setRating] = useState({
    value: '',
    label: '',
  })
  const [tags, setTags] = useState([])
  const [geoBlockCountries, setGeoBlockCountries] = useState([])

  const [errorData, setErrorData] = useState({})

  const [thumbnail, setThumbnail] = useState({
    website: '',
    mobile: '',
  })
  const [logo, setLogo] = useState({
    website: '',
    mobile: '',
  })
  const [banner, setBanner] = useState({
    website: '',
    mobile: '',
  })

  const [thumbnailData, setThumbnailData] = useState([
    {
      title: '',
      id: 'thumbnailWeb',
      uploadIconflexRow: true,
      width: 640,
      height: 360,
      divheight: '7.72vw',
      divwidth: '13.68vw',
      assetId: '',
      setAssetId: (id) => {
        handleClearError('thumbnail')
        setThumbnail({
          website: id,
          mobile: id,
        })
      },
      setImage: () => {},
      onRemoveImg: () => {},
      imageUrl: '',
    },
  ])

  const [logoData, setLogoData] = useState([
    {
      title: '',
      id: 'logoWeb',
      uploadIconflexRow: true,
      width: 250,
      height: 140,
      divheight: '7.72vw',
      divwidth: '13.68vw',
      assetId: '',
      setAssetId: (id) => {
        handleClearError('logo')
        setLogo({
          website: id,
          mobile: id,
        })
      },
      setImage: () => {},
      onRemoveImg: () => {},
      imageUrl: '',
    },
  ])

  const [bannerData, setBannerData] = useState([
    {
      title: '',
      id: 'bannerWeb',
      uploadIconflexRow: true,
      btnMarginTop: '.21vw',
      btnPadding: '3px',
      customOptionOneText: 'Asset Manager',
      hideUploadIcon: true,
      btnDivFlexRow: true,
      btnXmargin: 'mx-1',
      width: 1225,
      height: 191,
      divheight: '3.4vw',
      divwidth: '17.18vw',
      assetId: '',
      setAssetId: (id) => {
        handleClearError('banner')
        setBanner({
          website: id,
          mobile: id,
        })
      },
      setImage: () => {},
      onRemoveImg: () => {},
      imageUrl: '',
    },
  ])

  const isEdit = !isEmpty(data)

  useEffect(() => {
    if (!isEmpty(data)) {
      setChannelName(data?.name ? data?.name : '')
      setDescription(data?.description ? data?.description : '')
      setStatus(data?.status ? true : false)
      onEditPricing(data)
      let isCategoryActive = !isEmpty(masterAndChildIntersection(categoryMaster, data?.category))
      setCategory(
        isCategoryActive ? masterAndChildIntersection(categoryMaster, data?.category) : [],
      )

      setThumbnail({
        mobile: data?.thumbnail?.mobile?._id ? data?.thumbnail?.mobile?._id : '',
        website: data?.thumbnail?.website?._id ? data?.thumbnail?.website?._id : '',
      })
      setThumbnailData([
        {
          title: '',
          id: 'thumbnailWeb',
          uploadIconflexRow: true,
          width: 640,
          height: 360,
          divheight: '7.72vw',
          divwidth: '13.68vw',
          assetId: data['thumbnail']['website']['_id'],
          setAssetId: (id) => {
            handleClearError('thumbnail')
            setThumbnail({
              website: id,
              mobile: id,
            })
          },
          setImage: () => {},
          onRemoveImg: () => {},
          imageUrl: getThumbnail(
            userSessionObj.session_data.cf_domain_name,
            data?.thumbnail?.website?.s3_key,
          ),
        },
      ])

      setLogo({
        mobile: data?.logo?.mobile?._id ? data?.logo?.mobile?._id : '',
        website: data?.logo?.website?._id ? data?.logo?.website?._id : '',
      })
      setLogoData([
        {
          title: '',
          id: 'logoWeb',
          uploadIconflexRow: true,
          width: 250,
          height: 140,
          divheight: '7.72vw',
          divwidth: '13.68vw',
          assetId: data['logo']['website']['_id'],
          setAssetId: (id) => {
            handleClearError('logo')
            setLogo({
              website: id,
              mobile: id,
            })
          },
          setImage: () => {},
          onRemoveImg: () => {},
          imageUrl: getThumbnail(
            userSessionObj.session_data.cf_domain_name,
            data?.logo?.website?.s3_key,
          ),
        },
      ])

      setBanner({
        mobile: data?.banner?.mobile?._id ? data?.banner?.mobile?._id : '',
        website: data?.banner?.website?._id ? data?.banner?.website?._id : '',
      })
      setBannerData([
        {
          title: '',
          id: 'bannerWeb',
          uploadIconflexRow: true,
          btnMarginTop: '.21vw',
          btnPadding: '3px',
          customOptionOneText: 'Asset Manager',
          hideUploadIcon: true,
          btnDivFlexRow: true,
          btnXmargin: 'mx-1',
          width: 1225,
          height: 191,
          divheight: '3.4vw',
          divwidth: '17.18vw',
          assetId: data['banner']['website']['_id'],
          setAssetId: (id) => {
            handleClearError('banner')
            setBanner({
              website: id,
              mobile: id,
            })
          },
          setImage: () => {},
          onRemoveImg: () => {},
          imageUrl: getThumbnail(
            userSessionObj.session_data.cf_domain_name,
            data?.banner?.website?.s3_key,
          ),
        },
      ])

      const tempTag = data?.search_tags ? data['search_tags'] : []
      setTags(tempTag)
      setGeoBlockCountries(data?.geo_block_countries)

      if (data?.content_rating) {
        let isRatingActive = !isEmpty(
          masterAndChildIntersection(ratingMaster, [data?.content_rating]),
        )
        setRating(
          isRatingActive
            ? {
                value: data['content_rating']?._id,
                label: (
                  <div className="d-flex">
                    <img
                      style={{ width: '15px', height: '15px' }}
                      alt="rating"
                      src={getThumbnail(
                        userSessionObj.session_data.cf_domain_name,
                        data['content_rating']?.icon?.s3_key,
                      )}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null // prevents looping
                        currentTarget.src = ImageNotFound
                      }}
                      className="mx-1"
                    />
                    <span style={{ fontSize: '12px' }} className="d-flex align-items-center">
                      {data['content_rating']?.name}
                    </span>
                  </div>
                ),
              }
            : {},
        )
      }
    }
    setSubscriptions(subscriptionMaster)
  }, [data])

  const onEditPricing = (details) => {
    setIsRestricted(details?.is_restricted ? true : false)
    setPricingModel(details?.pricing_model ? details['pricing_model'] : [])
    if (!details?.is_restricted) return

    if (details['pricing_model'] && details['pricing_model'].includes('SUBSCRIPTION')) {
      setSubscriptions(masterAndChildIntersection(subscriptionMaster, details?.active_subscription))
    } else {
      setSubscriptions([])
    }

    if (details['pricing_model'] && details['pricing_model'].includes('PPV')) {
      setPpv(masterAndChildIntersection(PPVMaster, details?.active_ppv))
    } else {
      setPpv([])
    }
  }

  const handlePricingMethod = (value) => {
    if (value === 'subscription') {
      setPricingModel(['SUBSCRIPTION'])

      setSubscriptions(subscriptions)
      setPpv([])
    }
    if (value === 'payperview') {
      setPricingModel(['PPV'])

      setPpv(ppv)
      setSubscriptions([])
    }
    if (value === 'both') {
      setPricingModel(['SUBSCRIPTION', 'PPV'])

      setSubscriptions(subscriptions)

      setPpv(ppv)
    }
  }

  const handleRestriction = (value) => {
    setIsRestricted(value)
    if (value) {
      handlePricingMethod('subscription')
    } else {
      setSubscriptions([])

      setPpv([])
      setPricingModel([])
    }
  }

  const handleClearError = (field) => {
    if (errorData && errorData[field]) {
      // errorData[field] = ''
      setErrorData({ ...errorData, [field]: '' })
    }
  }

  const getRatingOptions = () => {
    return ratingMaster.map((info) => ({
      value: info?._id,
      label: (
        <div className="d-flex">
          <img
            style={{ width: '15px', height: '15px' }}
            alt="rating"
            src={getThumbnail(userSessionObj.session_data.cf_domain_name, info?.icon?.s3_key)}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null // prevents looping
              currentTarget.src = ImageNotFound
            }}
            className="mx-1"
          />
          <span style={{ fontSize: '12px' }} className="d-flex align-items-center">
            {info?.name}
          </span>
        </div>
      ),
    }))
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (channelName.trim().length === 0) {
      isFormValid = false
      temp.channelName = 'Channel Name cannot be empty!'
    }

    if (category.length === 0) {
      isFormValid = false
      temp.category = 'Select Category!'
    }

    if (!thumbnail.website) {
      isFormValid = false
      temp.thumbnail = 'Upload channel thumbnail!'
    }

    if (!logo.website) {
      isFormValid = false
      temp.logo = 'Upload channel logo!'
    }

    if (!banner.website) {
      isFormValid = false
      temp.banner = 'Upload channel banner!'
    }

    if (pricingModel.includes('SUBSCRIPTION') && isRestricted && subscriptions.length === 0) {
      isFormValid = false
      temp.subscription = 'ADD Subscription!'
    }
    if (pricingModel.includes('PPV') && isRestricted && ppv.length === 0) {
      isFormValid = false
      temp.ppv = 'ADD PPV!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return
    let payload = {
      name: channelName,
      description: description,
      category: category,
      is_restricted: isRestricted,
      pricing_model: pricingModel,
      active_subscription: subscriptions,
      active_ppv: ppv,
      status: status,
      thumbnail: thumbnail,
      logo: logo,
      banner: banner,
      geo_block_countries: geoBlockCountries,
      content_rating: rating?.value ? ratingMaster.find((item) => item._id === rating.value) : '',
      search_tags: tags,
    }
    if (isEmpty(data)) {
      onCreate(payload)
      return
    } else {
      let editData = JSON.parse(JSON.stringify(data))
      delete editData['_id']
      delete editData['account_id']
      delete editData['created_date']
      delete editData['created_by']
      onUpdate({ ...editData, ...payload }, data?._id)
      return
    }
  }

  return (
    <CModal scrollable size="xl" visible={true} className="create-channel-modal">
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CModalBody className="p-0">
        <div style={{ padding: '2vw 1.2vw 1vw', height: '100%', color: '#191818' }}>
          <h1 style={{ fontSize: '1.5vw', marginBlockEnd: '0', fontWeight: 'bolder' }}>
            {isEdit ? 'EDIT ' : `ADD NEW `} CHANNEL
          </h1>
          <div className="d-flex justify-content-between" style={{ gap: '1vw', marginTop: '1vw' }}>
            {/* left side div */}
            <div
              className="rounded-1 custom-scrollbar-vertical"
              style={{
                padding: '.8vw 3%',
                width: '59%',
                aspectRatio: '753/698',
                // height: '100%',
                overflowY: 'scroll',
                backgroundColor: '#eeeeee',
                border: 'solid 0.5px #707070',
                boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.31)',
              }}
            >
              <h1 style={{ fontSize: '1.1vw', marginBlockEnd: '.5vw', fontWeight: 'bolder' }}>
                BASIC INFORMATION
              </h1>
              <div
                style={{ paddingBottom: '2.1vw' }}
                className=" border-bottom border-bottom-secondary"
              >
                <div>
                  <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                    Channel Name<span className="asterisk">*</span>
                  </h6>
                  <CustomDescriptionBox
                    limit={100}
                    rows={1}
                    placeholder="Title of the Content"
                    value={channelName}
                    onChange={(value) => {
                      handleClearError('channelName')
                      setChannelName(value)
                    }}
                    isMandatory={true}
                    errorText={errorData.channelName}
                    style={{ fontSize: '12px', borderRadius: '2px' }}
                    limitFontSize={'11px'}
                  />
                </div>
                <div style={{ marginTop: '.2vw' }}>
                  <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                    Description
                  </h6>
                  <CustomDescriptionBox
                    limit={500}
                    rows={3}
                    placeholder="Description of the Content within 500 Characters"
                    value={description}
                    onChange={setDescription}
                    isMandatory={true}
                    // errorText={descriptionError}
                    // clearError={() => setDescriptionError('')}
                    style={{ fontSize: '12px', borderRadius: '2px', height: '' }}
                    limitFontSize={'11px'}
                  />
                </div>
                <div style={{ marginTop: '.95vw' }}>
                  <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                    Category<span className="asterisk">*</span>
                  </h6>
                  <div>
                    <CustomMultiSelect
                      selectedValue={category}
                      optionsData={categoryMaster}
                      onChange={(value) => {
                        handleClearError('category')
                        setCategory(value)
                      }}
                      labelKey="name"
                    />
                    <div className="message-text error-message">
                      <p>{errorData.category}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="py-3"
                style={{
                  backgroundColor: '#eeeeee',
                }}
              >
                <h4 style={{ fontSize: '1.1vw', fontWeight: '700' }}>SET PRICING</h4>
                <p style={{ fontSize: '12px' }}>
                  Please be sure that appropriate Pricing settings are already done. Otherwise go to
                  the Pricing for more settings.
                </p>
                <div className="py-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <h4 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                      Access method
                    </h4>
                    <div
                      className="mx- d-flex justify-content-start align-items-center rounded-1 overflow-hidden"
                      style={{ border: '0.5px solid #707070' }}
                    >
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          height: '2.13vw',
                          backgroundColor: isRestricted ? '#000' : '#fff',
                          color: isRestricted ? '#fff' : '#000',
                          padding: '8px 26px',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleRestriction(true)}
                      >
                        <img
                          src={PricedIcon}
                          alt=""
                          className="h-100"
                          style={{ filter: isRestricted ? 'invert(0)' : 'invert(1)' }}
                        />
                        <p
                          style={{
                            marginLeft: '1em',
                            marginBlock: '0',
                            fontWeight: isRestricted ? '600' : '400',
                            fontSize: '.75vw',
                          }}
                        >
                          PAID
                        </p>
                      </div>
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          height: '2.13vw',
                          color: isRestricted ? '#000' : '#fff',
                          backgroundColor: isRestricted ? '#fff' : '#000',
                          padding: '8px 26px',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleRestriction(false)}
                      >
                        <img
                          src={FreeGiftIcon}
                          alt=""
                          className="h-100"
                          style={{ filter: isRestricted ? 'invert(0)' : 'invert(1)' }}
                        />
                        <p
                          style={{
                            marginLeft: '1em',
                            marginBlock: '0',
                            fontWeight: isRestricted ? '400' : '600',
                            fontSize: '.75vw',
                          }}
                        >
                          FREE
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ marginBottom: '2.1vw' }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <h4 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                      Select the Pricing method
                    </h4>
                    <div
                      className="mx- d-flex justify-content-start align-items-center rounded-1 overflow-hidden"
                      style={{ border: '0.5px solid #707070' }}
                    >
                      <CCol>
                        <CFormCheck
                          className="channel-cformcheck"
                          type="radio"
                          id="flexRadioDefault1"
                          label="SUBSCRIPTION"
                          value="subscription"
                          checked={
                            pricingModel.includes('SUBSCRIPTION') && pricingModel.length === 1
                          }
                          onChange={(e) => handlePricingMethod(e.target.value)}
                          disabled={!isRestricted}
                        />
                      </CCol>
                      <CCol className="center-form-check">
                        <CFormCheck
                          className="channel-cformcheck"
                          type="radio"
                          id="flexRadioDefault2"
                          label="PAY-PER-VIEW"
                          value="payperview"
                          checked={pricingModel.includes('PPV') && pricingModel.length === 1}
                          onChange={(e) => handlePricingMethod(e.target.value)}
                          disabled={!isRestricted}
                        />
                      </CCol>
                      <CCol className="center-form-check">
                        <CFormCheck
                          className="channel-cformcheck"
                          type="radio"
                          id="flexRadioDefault3"
                          label="BOTH"
                          value="both"
                          checked={pricingModel.length === 2}
                          onChange={(e) => handlePricingMethod(e.target.value)}
                          disabled={!isRestricted}
                        />
                      </CCol>
                    </div>
                  </div>
                  <div
                    style={{ marginTop: '.95vw', gap: '0 2vw', marginBottom: 'vw' }}
                    // className="d-flex"
                  >
                    {pricingModel.includes('SUBSCRIPTION') && (
                      <div className="w-100">
                        <h6 style={{ fontSize: '.8vw', marginBottom: '.45vw' }} className="">
                          Select the Subscription Plan
                        </h6>
                        <CustomMultiSelect
                          selectedValue={subscriptions}
                          optionsData={subscriptionMaster}
                          onChange={setSubscriptions}
                          labelKey="name"
                        />
                        <div className="message-text error-message">
                          <p>{errorData.subscription}</p>
                        </div>
                      </div>
                    )}
                    {pricingModel.includes('PPV') && (
                      <div className="w-100 mt-3">
                        <h6 style={{ fontSize: '.8vw', marginBottom: '.45vw' }} className="">
                          Select the Pay-per-View Plan
                        </h6>
                        <CustomMultiSelect
                          selectedValue={ppv}
                          optionsData={PPVMaster}
                          onChange={setPpv}
                          labelKey="name"
                        />
                        <div className="message-text error-message">
                          <p>{errorData.ppv}</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="py-2 border-bottom-1 border-top-secondary border-top">
                  <h4 style={{ fontSize: '1.1vw', fontWeight: '700', marginBlock: '0' }}>STATUS</h4>
                  <p style={{ fontSize: '12px' }}>
                    Set your channel visibility status on the IPTV channel list
                  </p>
                  <div
                    className="d-inline-flex justify-content-start align-items-center rounded-1 overflow-hidden"
                    style={{ border: '0.5px solid #707070' }}
                  >
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        height: '2.13vw',
                        backgroundColor: status ? '#000' : '#fff',
                        color: status ? '#fff' : '#000',
                        padding: '8px 26px',
                        cursor: 'pointer',
                      }}
                      onClick={() => setStatus(true)}
                    >
                      <p
                        style={{
                          marginBlock: '0',
                          fontWeight: status ? '600' : '400',
                          fontSize: '.75vw',
                        }}
                      >
                        Enable (ON)
                      </p>
                    </div>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        height: '2.13vw',
                        color: status ? '#000' : '#fff',
                        backgroundColor: status ? '#fff' : '#000',
                        padding: '8px 26px',
                        cursor: 'pointer',
                      }}
                      onClick={() => setStatus(false)}
                    >
                      <p
                        style={{
                          marginBlock: '0',
                          fontWeight: status ? '400' : '600',
                          fontSize: '.75vw',
                        }}
                      >
                        DISABLE (OFF)
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="py-2 border-bottom-1 border-top-secondary border-top"
                  style={{ marginTop: '2.1vw' }}
                >
                  <h4 style={{ fontSize: '1.1vw', fontWeight: '700', marginBlock: '0' }}>
                    PROPERTIES
                  </h4>
                  <p style={{ fontSize: '12px' }}>Set your channel properties</p>
                  <div style={{ marginTop: '.95vw' }}>
                    <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                      Censorship Rating
                    </h6>
                    <div>
                      <Select
                        value={rating}
                        onChange={setRating}
                        options={getRatingOptions()}
                        isSearchable={false}
                        styles={{ height: '30px' }}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: '.95vw' }}>
                    <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                      Search Tag{' '}
                      <span style={{ fontWeight: '400', marginLeft: '.75rem', fontSize: '12px' }}>
                        (Input Text and Press Enter to add a Tag)
                      </span>
                    </h6>
                    <div className="text-left">
                      <TagsInput
                        value={tags}
                        onChange={(tag) => {
                          setTags(tag)
                        }}
                      />
                    </div>
                  </div>
                  {isGeoBlockAllowed && (
                    <div style={{ marginTop: '.95vw' }}>
                      <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                        Geo-Blocking
                      </h6>
                      <div>
                        <CustomMultiSelect
                          selectedValue={geoBlockCountries}
                          optionsData={!isEmpty(countriesMaster) ? countriesMaster : []}
                          onChange={setGeoBlockCountries}
                          labelKey="name"
                          valueKey="iso2"
                        />
                        <div className="message-text error-message">
                          <p>{errorData.geoBlockCountries}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* left side div */}
            {/* right side div */}
            <div
              className="d-flex flex-column align-items-center justify-content-evenly rounded-1"
              style={{
                width: '37%',
                // height: '100%',
                backgroundColor: '#eeeeee',
                border: 'solid 0.5px #707070',
                boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.31)',
              }}
            >
              <div className="d-flex flex-column align-items-center">
                <h6 style={{ fontWeight: '600' }}>
                  Upload Channel Thumbnail Image<span className="asterisk">*</span>
                </h6>
                <div
                  style={{ textAlign: 'center', marginTop: '-1rem' }}
                  className="d-flex flex-column align-items-center"
                >
                  <ImageUploader data={thumbnailData} />
                  <div className="message-text error-message">
                    <p>{errorData.thumbnail}</p>
                  </div>
                  <div
                    className="message-text mt-1 italic"
                    style={{ color: '#707070', padding: '0 1.75vw' }}
                  >
                    <p>The image file should be 640x360 pixels . Format should be .jpeg or .png.</p>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column align-items-center">
                <h6 style={{ fontWeight: '600' }}>
                  Upload Channel Logo<span className="asterisk">*</span>
                </h6>
                <div
                  style={{ textAlign: 'center', marginTop: '-1rem' }}
                  className="d-flex flex-column align-items-center"
                >
                  <ImageUploader data={logoData} />
                  <div className="message-text error-message">
                    <p>{errorData.logo}</p>
                  </div>
                  <div
                    className="message-text mt-1 italic"
                    style={{ color: '#707070', padding: '0 1.75vw' }}
                  >
                    <p>The image file should be 250x140 pixels. Format should be .jpeg or .png.</p>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column align-items-center">
                <h6 style={{ fontWeight: '600' }}>
                  Upload Promotional Banner<span className="asterisk">*</span>
                </h6>
                <div
                  style={{ textAlign: 'center', marginTop: '-1rem' }}
                  className="d-flex flex-column align-items-center"
                >
                  <ImageUploader data={bannerData} />
                  <div className="message-text error-message">
                    <p>{errorData.banner}</p>
                  </div>
                  <div
                    className="message-text mt-1 italic"
                    style={{ color: '#707070', padding: '0 1.75vw' }}
                  >
                    <p>The image file should be 1225x191 pixels.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CModalBody>
      <CModalFooter className="border-0 p-0">
        <div className={` mb-0 d-flex `} style={{ padding: '1vw' }}>
          <div style={{ marginLeft: 'auto' }}>
            <CButton
              className=""
              style={{
                color: '#3a3838',
                backgroundColor: 'white',
                marginRight: '2rem',
                border: '1px solid #bdbdbd',
                borderRadius: '5px',
              }}
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton
              className="text-white"
              onClick={handleSave}
              style={{
                color: 'white',
                backgroundColor: '#20211c',
                border: '1px solid #bdbdbd',
                borderRadius: '5px',
              }}
            >
              {isEdit ? 'Update' : 'Create'}
            </CButton>
          </div>
        </div>
      </CModalFooter>
    </CModal>
  )
}

export default CreateChannelModal
